import { createSlice } from "@reduxjs/toolkit";
import {     home_portfolioThunk } from "./thunk";


export const initialState = {
  home_portfolioData: [],
  home_portfolioError: {
    code: null,
    message: '',
    data: null
  },
  home_portfolioLoading: false,
  
  
};

const Home_Portfolio = createSlice({
  name: "Home_Portfolio",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(home_portfolioThunk.pending, (state) => {
      state.home_portfolioLoading = true ;
      state.home_portfolioError = initialState.home_portfolioError; 
  });
    builder.addCase(home_portfolioThunk.fulfilled, (state, action) => {
        state.home_portfolioData = action.payload.data;
        state.home_portfolioLoading = false ;
    });
    builder.addCase(home_portfolioThunk.rejected, (state, action) => {
      state.home_portfolioError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.home_portfolioLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Home_Portfolio.actions

export default Home_Portfolio.reducer;